import { Row, Col } from "react-bootstrap";
import SquareBox from "./SquareBoxMenu";
import image1 from "../assets/images/icon.png";
import { useWindowWidth } from "../context/WindowWidthContext";

const SessionMenu = () => {
  const { isMobile } = useWindowWidth();
  return (
    <Row
      style={{
        padding: !isMobile ? "20px 30px 10px 30px" : "10px 0px 10px 0px",
      }}
    >
      <Col md={3} xs={4}>
        <SquareBox
          imageUrl={image1}
          name={"PIANO CHO BÉ"}
          description={"Bộ giáo trình cho bé"}
          url={"/new-dance"}
        />
      </Col>
      <Col md={3} xs={4}>
        <SquareBox
          imageUrl={image1}
          name={"PIANO CHO BỐ MẸ"}
          description={"Bộ giáo trình cho bố mẹ"}
          url={"/dance-song"}
        />
      </Col>
      <Col md={3} xs={4}>
        <SquareBox
          imageUrl={image1}
          name={"PIANO NÂNG CAO"}
          description={"Bộ giáo trình nâng cao"}
          url={"/dance-advanced"}
        />
      </Col>
      {!isMobile && (
        <Col md={3} xs={4}>
          <SquareBox
            imageUrl={image1}
            name={"UPDATE"}
            description={"Piano update"}
            url={"/update-category"}
          />
        </Col>
      )}
    </Row>
  );
};

export default SessionMenu;
